export const sendVirtualPageView = (pageTitle) => {
    /* eslint-disable */
    if (typeof _etracker === 'object') {
        et_eC_Wrapper({
            et_et: process.env.REACT_APP_ETRACKER_ID,
            et_pagename: `${process.env.REACT_APP_PROJECT_TITLE}: ${pageTitle} [VPV]`,
        });
    }
    /* eslint-disable */
};

// Append current page URL search parameters (referral / tracking / UTM params) to a destination link
export const appendReferralParams = (url) => {
    if (!url || url === '#') return '#';
    try {
        const currentSearch = typeof window !== 'undefined' ? window.location.search : '';
        if (!currentSearch) return url;

        const currentParams = new URLSearchParams(currentSearch);
        if ([...currentParams.keys()].length === 0) return url;

        const isRelative = !/^https?:\/\//i.test(url);
        const baseUrl = isRelative && typeof window !== 'undefined' ? window.location.origin : 'https://localhost';
        const target = new URL(url, baseUrl);

        currentParams.forEach((value, key) => {
            if (!target.searchParams.has(key)) {
                target.searchParams.set(key, value);
            }
        });

        return isRelative ? `${target.pathname}${target.search}${target.hash}` : target.toString();
    } catch {
        return url;
    }
};
